import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { translate } from 'react-i18next';
import { Helmet } from 'react-helmet';

import AdminTitleBar from 'Parts/common/AdminTitleBar';
import EventAdminAttendeesTicketForm from '../components/EventAdminAttendeesTicketFormContainer';
import AdminBackButtonBar from 'Parts/common/AdminBackButtonBar';

import EventAdminAttendeesTicketPageEN from './locales/EventAdminAttendeesTicketPage_en.json';
import EventAdminAttendeesTicketPageFR from './locales/EventAdminAttendeesTicketPage_fr.json';

import './EventAdminAttendeesTicketPage.less';

class EventAdminAttendeesTicketPage extends React.Component {
  constructor(props) {
    super(props);

    i18next.addResourceBundle('en', 'EventAdminAttendeesTicketPage', EventAdminAttendeesTicketPageEN);
    i18next.addResourceBundle('fr', 'EventAdminAttendeesTicketPage', EventAdminAttendeesTicketPageFR);
  }

  render() {
    const { locale, t, campaignId } = this.props;

    const url = `/${locale}/d/campaigns/${campaignId}/attendees/checkin`;

    return (
    <div className="EventAdminAttendeesTicketPage">
        <Helmet>
          <title>{t('Ticket information')}</title>
        </Helmet>
        <AdminBackButtonBar href={url} text={t('back')} />
        <AdminTitleBar title={t('Ticket information')} />
        <div className="AdminPanel">
          {/* <Can rules={['permissions.campaign.campaign.update']} redirect={`/${locale}/d`}> */}
            <EventAdminAttendeesTicketForm {...this.props} />
          {/* </Can> */}
        </div>
    </div>
    );
  }
}

EventAdminAttendeesTicketPage.propTypes = {};

EventAdminAttendeesTicketPage.defaultProps = {
  campaignID: null
};


export default translate('EventAdminAttendeesTicketPage')(EventAdminAttendeesTicketPage);
